import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import Analytics from "../../../../client/analytics";
function EmbeddedAnalyticsWrapper() {
    var commonProperties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return _object_spread_props(_object_spread({}, Analytics), {
        // eslint-disable-next-line default-param-last
        track: function(event, properties, options, callback) {
            Analytics.track(event, _object_spread({}, commonProperties, properties), options, callback);
        },
        // eslint-disable-next-line default-param-last
        page: function(category, name, properties, options, callback) {
            Analytics.page(category, name, _object_spread({}, commonProperties, properties), options, callback);
        }
    });
}
var AnalyticsContext = /*#__PURE__*/ React.createContext(Analytics);
function AnalyticsProvider(param) {
    var storeId = param.storeId, storeName = param.storeName, isSandbox = param.isSandbox, checkoutType = param.checkoutType, children = param.children;
    var wrapper = EmbeddedAnalyticsWrapper({
        storeId: storeId,
        storeName: storeName,
        isSandbox: isSandbox,
        checkoutType: checkoutType
    });
    return /*#__PURE__*/ _jsx(AnalyticsContext.Provider, {
        value: wrapper,
        children: children
    });
}
export function useAnalytics() {
    return useContext(AnalyticsContext);
}
export default AnalyticsProvider;
